module.exports = __webpack_public_path__ + "static/img/roadmap-banner.d52083a5.png";